import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { applyPwaUpdate, hasPwaUpdateAvailable, subscribeToPwaUpdateAvailable } from '../../registerPwa';
import { useMeasuredBottomSnackbarStackIndex } from './SnackbarStackContext';
import { bottomCenterSnackbarStackSx, defaultSnackbarContentSx } from './snackbarStyles';

interface PwaUpdateSnackbarProps {
  stackIndex?: number;
}

const PwaUpdateSnackbar = ({ stackIndex: stackIndexOverride }: PwaUpdateSnackbarProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isApplying, setIsApplying] = useState(false);
  const { ref: snackbarRef, stackIndex: registeredStackIndex } = useMeasuredBottomSnackbarStackIndex<HTMLDivElement>({
    disabled: stackIndexOverride !== undefined,
    horizontal: 'center',
    open,
  });
  const stackIndex = stackIndexOverride ?? registeredStackIndex;

  useEffect(
    () =>
      subscribeToPwaUpdateAvailable(() => {
        setIsApplying(false);
        setOpen(hasPwaUpdateAvailable());
      }),
    []
  );

  const handleRefresh = () => {
    if (applyPwaUpdate()) {
      setIsApplying(true);
    }
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      ref={snackbarRef}
      open={open}
      message={t('pwaUpdate.message', { defaultValue: 'A new version is available.' })}
      action={
        <Button color="primary" size="small" onClick={handleRefresh} disabled={isApplying}>
          {t('pwaUpdate.action.refresh', { defaultValue: 'Refresh' })}
        </Button>
      }
      slotProps={{
        content: {
          sx: defaultSnackbarContentSx,
        },
      }}
      sx={bottomCenterSnackbarStackSx(stackIndex)}
    />
  );
};

export default PwaUpdateSnackbar;
